import styled from 'styled-components';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 16px 24px 8px;
  overflow: hidden;
`;

export const Label = styled.div`
  color: #1a1b1c;
  font-weight: 500;
  font-size: 16px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  height: auto;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 19px;
`;

export const Input = styled.input`
  border-radius: 8px;
  border: 1px solid #e9edf1;
  background: #fff;
  color: #838a91;
  font-size: 16px;
  padding: 5px 12px;
  width: 100%;
`;

export const Block = styled.div`
  background: #fff;
  padding: 12px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  position: absolute;
  top: 0;
  left: 100%;
  min-width: 200px;
  min-height: 200px;
  z-index: 11;
`;

interface IItem {
  active: boolean;
}

export const Item = styled.div<IItem>`
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  background: ${({ active }) => (active ? '#F6F8FF' : '#fff')};
  cursor: pointer;
`;

export const ItemText = styled.div`
  color: #1a1b1c;
  font-size: 16px;
  flex: 1;
`;

export const ItemList = styled.div`
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;

  & + & {
    margin-top: 16px;
  }
`;

interface IItemListText {
  active: boolean;
}

export const ItemListText = styled.div<IItemListText>`
  font-size: 14px;
  flex: 1;
  color: ${({ active }) => (active ? '#1371FE' : '#1a1b1c')};
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Cancel = styled.button`
  color: #838a91;
  font-size: 14px;
  background: none;
  border: none;
`;

interface IConfirm {
  active: boolean;
}

export const Confirm = styled.button<IConfirm>`
  color: #1371fe;
  font-size: 14px;
  cursor: pointer;
  background: none;
  border: none;
  opacity: ${({ active }) => (active ? '1' : '0.3')};
`;
export const ScrollDiv = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
  width: 100%;
  align-items: flex-start;
  padding-right: 1px;
`;
export const ProductDiv = styled.div`
  border-radius: 8px;
  height: 48px;
  min-height: 48px;
  width: 99.9%;
  margin-left: 1px;
  box-shadow: 0px 1px 4px 0px #00000029;
  //border: solid 1px blue;
  margin-bottom: 16px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 12px;
  padding-right: 12px;
`;
export const CheckCircle = styled(CheckCircleIcon)`
  color: ${beam.color.primaryBlue};
  margin-right: 16px;
  cursor: pointer;
`;
export const ProductText = styled.span`
  font-weight: 400;
  color: ${beam.font.primary};
  overflow: hidden;
  position: relative;
  white-space: nowrap;
  text-align: start;
  font-size: 16px;
  :after {
    content: '';
    width: 40px;
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
    right: 0;
    position: absolute;
    background: -webkit-linear-gradient(
      left,
      rgba(255, 255, 255, 0) 70%,
      #fff 95%
    );
    height: 38px;
    z-index: 4;
  }
`;
export const Close = styled.img`
  cursor: pointer;
  align-self: center;
  height: 10px;
  width: 10px;
`;
